const Table = require('./Table');
const Column = require('./Column');
const ColumnGroup = require('./ColumnGroup');

Table.Column = Column;
Table.ColumnGroup = ColumnGroup;

module.exports = Table;



// WEBPACK FOOTER //
// ./src/index.js